import { usePublicTranslationContext } from '../context/PublicTranslationContext';

export const usePublicTranslation = () => {
    // Delegates to the context, making all components reactive
    const context = usePublicTranslationContext();
    return context;
};
